
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8.467 8.467","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m3.4384463 0c-.441327 0-.7926521.35755987-.7926521.79271966v2.11717904c0 .36078.5291234.36078.5291234 0v-2.11717904c0-.15114992.1196186-.26354987.2635287-.26354987h4.2355699c.1511424 0 .2635271.12272995.2635271.26354987v6.88122714c0 .14289-.1123847.2635499-.2635271.2635499h-4.2355699c-.1511445 0-.2635287-.1206599-.2635287-.2635499v-2.1171792c0-.3502899-.5291234-.3554497-.5291234 0v2.1171792c0 .4403297.3575268.7927196.7926521.7927196h4.2355699c.4351252 0 .7926505-.3523899.7926505-.7927196v-6.88122714c0-.43515979-.3523589-.79271966-.7926505-.79271966zm-2.0389849 2.7243988-1.32229164 1.3223995c-.10289302.1029015-.10289301.2702083 0 .3731098l1.32229164 1.3223995c.2500934.2501199.6252338-.1250598.3751403-.3751699l-.87067673-.8691995h4.65359753c.3524042 0 .3524042-.5291698 0-.5291698h-4.65204766l.86912686-.8691897c.2485863-.2692845-.1298358-.6156529-.3751403-.3751799z"}})])
          )
        }
      }
    